// extracted by css-extract-rspack-plugin
export default {"root":"root-f8ieqY","divider":"divider-jb0E4H","sideActions":"sideActions-dtmsBd","sideActionBase":"sideActionBase-Zx_amj","sideAction":"sideAction-VnNmW7 sideActionBase-Zx_amj"};